import React, { useState, useEffect } from "react";
import { Typography, Container } from "@mui/material";
import CustomAppBar from "../../components/AppBar";
import api from "../../globals/axios";
import LoaderContainer from "../../components/LoaderContainer";
import { useTranslation } from "react-i18next";
import CustomCard from "../../components/Famer/GenericCard";
import CustomButton from "../../components/Custom/CustomButton";
import { CustomTitle } from "../../components/Custom/CustomTypography";
import OrgnizationDetailsIcon from "../../assets/Icon/OrganizationFpoIconpng.png";
import ConfirmationPopup from "../../components/Popup/GenericPopup";
import { useAlert } from "../../components/Alert";
import { useNavigate } from "react-router-dom";

export default function FPOData() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const { showAlert } = useAlert();
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  useEffect(() => {
    api
      .get("/fpo/fpo-details-get-set")
      .then((response) => {
        setData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching lenders:", error);
        setLoading(false);
      });
  }, []);

  const handleDelete = () => {
    setDeleteConfirmationOpen(true);
  };
  const handleConfirmDelete = () => {
    api
      .delete(`/fpo/fpo-details-get-set`)
      .then((response) => {
        console.log("Organization deleted successfully", response);
        showAlert("success", "Deleted Successfully");
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error deleting organization:", error);
        showAlert("error", "Some issue on Deleting the Farmer");
      });
  };

  const handleAddOrganization = () => {
    navigate("/fpo/create-organization/");
  };
  const handleEditClick = (ordId) => {
    navigate(`/fpo/create-organization/?ordId=${ordId}`);
  };

  console.log("data", data);
  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container maxWidth="xs">
          {data.length !== 0 && (
            <div
              style={{
                overflowY: "auto",
                maxHeight: "calc(115vh - 300px)",
                textAlign: "center",
                height: "700px",
                margin: "auto",
              }}
            >
              <CustomTitle>{t("Organization Details")}</CustomTitle>
              <CustomCard
                key={data.id}
                id={data.id}
                t={t}
                data={{
                  [t("Organization Name")]: data.name,
                  [t("Year of Incorporation")]: data.year_of_incorporation,
                  [t("PAN Number")]: data.pan_number,
                  [t("Address")]: data.address,
                }}
                handleEditClick={() => handleEditClick(data.id)}
                handleDelete={() => handleDelete(data.id)}
              />
            </div>
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: data.length !== 0 ? "0px" : "90vh",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {data.length === 0 && (
                <div style={{ marginBottom: "30px" }}>
                  <img
                    src={OrgnizationDetailsIcon}
                    alt="Orginazation"
                    style={{
                      width: "127px",
                      height: "127px",
                      marginBottom: "10px",
                    }}
                  />
                </div>
              )}
              {data.length === 0 && (
                <>
                  <CustomButton onClick={handleAddOrganization}>
                    {t("Add Organization Details")}
                  </CustomButton>
                  <Typography
                    variant="subtitle1"
                    sx={{ mb: 2, textAlign: "center" }}
                  >
                    {t("Your Details will be shown here once you add them.")}
                  </Typography>
                </>
              )}
            </div>
          </div>
        </Container>
      </LoaderContainer>
      <ConfirmationPopup
        open={deleteConfirmationOpen}
        handleClose={() => setDeleteConfirmationOpen(false)}
        handleConfirm={handleConfirmDelete}
        title="Confirm Delete"
        message="Are you sure you want to delete this member?"
        confirmButtonText="Delete"
        cancelButtonText="Cancel"
      />
    </>
  );
}
